<template>
  <div>
    <Navbar v-if="showNavbar" />
    <router-view></router-view>
  </div>
</template>

<script>

import Navbar from "./examples/PageLayout/Navbar.vue";

export default {
  
  components: {
    Navbar,
  },
  computed: {
    showNavbar() {
      return this.$route.meta.requiresAuth;
    },
  },
  mounted() {
    // this.$notify(
    //   {
    //     component: NotificationSample,
    //     icon: 'nc-icon nc-app'
    //   })
  },
};
</script>

<style lang="css" >
.el-select .el-input:hover input {
  color: black;
}

.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #F5F7FA;
  border-color: #8e8e8e;
}

.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #000000;
}
.el-checkbox__input.is-disabled .el-checkbox__inner {
  background-color: #F5F7FA;
  border-color: #8e8e8e;
    cursor: not-allowed;
}

.el-input.is-disabled .el-input__inner {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #707887;
  cursor: not-allowed;
}

.el-button[disabled],
.el-button:disabled {
  opacity: 0.6 !important;
}


.el-radio__input.is-disabled+span.el-radio__label {
  color: #707887;
  cursor: not-allowed;
}

.el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  background-color: #707887;
}

.el-radio__input.is-disabled .el-radio__inner,
.el-radio__input.is-disabled.is-checked .el-radio__inner {
  background-color: #F5F7FA;
  border-color: #707887;
}

.el-textarea.is-disabled .el-textarea__inner {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #707887;
  cursor: not-allowed;
}

.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected {
  background-color: #F5F7FA !important;
  cursor: var(--vs-disabled-cursor);
  border-color: #E4E7ED;
}

/* .vs--disabled .vs__search,
.vs--disabled .vs__search:focus {
  display: none !important;
} */

.vs__search,
.vs__search:focus {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: none;
  border: 1px solid transparent;
  border-left: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #565f74 !important;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  font-size: 0.8rem !important;
  line-height: var(--vs-line-height);
  margin: 4px 0 0;
  max-width: 100%;
  outline: none;
  padding: 0 7px;
  width: 0;
  z-index: 1;
  margin-left: 5px !important;
}


.vs__selected {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: var(--vs-selected-bg);
  border: var(--vs-selected-border-width) var(--vs-selected-border-style) rgb(204 124 124 / 26%);
  border-radius: var(--vs-border-radius);
  color: #606266 !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  line-height: var(--vs-line-height);
  margin: 4px 2px 0;
  padding: 0 .25em;
  z-index: 0;
  margin-left: 10px !important;
}

#my-select .vue-select .vs__dropdown-toggle,
.vue-select .vs__dropdown-menu .vs__option {
  font-size: 12px !important;
}

.vs__clear {
  display: none;
}

/* .el-dialog__body {
  padding: 0px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.el-dialog__header {
    padding: 10px 20px 10px;
  } */

/* body {
  background-image: url('./assets/azer.png');
  background-repeat: no-repeat;
  background-size: 500px;
} */

/* .main-panel .content {

  background-image: url('./assets/azer.png');
  background-size: 100%;
}

.main-panel .navbar {

background-image: url('./assets/azer.png');
background-size: 100%;
}
.justify-content-between {
  background-image: url('./assets/azer.png');
background-size: 100%;
    -ms-flex-pack: justify !important;
    -webkit-box-pack: justify !important;
    justify-content: space-between !important;
} */

/* .sidebar-wrapper {
  background-color: midnightblue;
} */
.el-table__body tr:nth-child(odd) {
  background-color: #ffffff;
}

.el-table__body tr:nth-child(even) {
  background-color: #f9f9f9;
}
.el-table thead th {
  font-weight: 500 !important;
  background-color: #F5F5F5 !important;
}
:root {
  --el-text-color-regular: #222222 !important;
  --el-text-color-secondary: #555555 !important;
}
h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: #495057 !important;
}
.el-table {
  font-size: 13px !important;
}
.el-table .el-table__cell {
    box-sizing: border-box;
    min-width: 0;
    padding: 4px 0 !important;
    position: relative;
    text-align: left;
    text-overflow: ellipsis;
    vertical-align: middle;
    z-index: var(--el-table-index);
}

.el-table--border .el-table__inner-wrapper:after {
    height: 1px;
    left: 0;
    top: 0;
    width: 100%;
    z-index: calc(var(--el-table-index)) !important;
}
</style>

